import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "out-of-production-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Nylig utgåtte varer", -1)
const _hoisted_3 = { class: "type-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, " Utgått mellom " + _toDisplayString(_ctx.fromDate?.format("LL")) + " og " + _toDisplayString(_ctx.dayjs().format("LL")), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_ProductList, {
        products: _ctx.products,
        "is-admin": _ctx.isAdmin,
        "show-print-button": false,
        "print-mode": true,
        "show-wc-id": false
      }, null, 8, ["products", "is-admin"])
    ])
  ]))
}